import { Transform } from "class-transformer";
import { toISODateString } from "./utils";
export function TransformBigInt() {
    const toClassOnly = Transform(({ value }) => (value === undefined || value === null ? value : BigInt(value)), {
        toClassOnly: true,
    });
    const toPlainOnly = Transform(({ value }) => (value === undefined || value === null ? value : value.toString()), {
        toPlainOnly: true,
    });
    return (target, propertyKey) => {
        toClassOnly(target, propertyKey);
        toPlainOnly(target, propertyKey);
    };
}
export function TransformDateOnly() {
    const toClassOnly = Transform(({ value }) => (value === undefined || value === null ? value : new Date(value)), {
        toClassOnly: true,
    });
    const toPlainOnly = Transform(({ value }) => (value === undefined || value === null ? value : toISODateString(value)), {
        toPlainOnly: true,
    });
    return (target, propertyKey) => {
        toClassOnly(target, propertyKey);
        toPlainOnly(target, propertyKey);
    };
}
